import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import styled from 'styled-components';

import colors from 'shared-assets/lib/colors';

const size = '1.5rem';

const StyledButton = styled.button`
  background: transparent;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: ${size};
  height: ${size};
  cursor: pointer;
  outline: none;

  &:hover {
    background: rgba(${colors.secondaryRGB.join(', ')}, 0.08);
  }

  &:active,
  &.active {
    background: rgba(${colors.secondaryRGB.join(', ')}, 0.16);
  }

  &:hover + .tag {
    display: block;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    max-height: 0.75rem;
    max-width: 0.75rem;
    width: auto;
    height: auto;
  }

  svg path {
    fill: ${colors.secondary};
  }
`;

const Tip = styled.span`
  border-radius: 2px;
  background-color: ${colors.secondary};
  color: #fff;
  font-size: 0.8125rem;
  line-height: 0.8125rem;
  padding: 0.25rem;
  font-weight: 600;
`;

const Wrapper = styled.div`
  position: relative;

  .tag {
    display: none;
    position: absolute;
    top: calc(${size} + 0.25rem);
    white-space: nowrap;
  }
`;

const IconButton = React.forwardRef((props, ref) => {
  return (
    <Wrapper>
      <StyledButton ref={ref} type="button" {...props}>
        <SVG
          cacheGetRequests
          key={props.icon}
          src={`/static/assets/icons/${props.icon}.svg`}
        />
      </StyledButton>
      <If condition={props.tip}>
        <Tip className="tag" type="subtle">
          {props.tip}
        </Tip>
      </If>
    </Wrapper>
  );
});

IconButton.displayName = 'IconButton';

IconButton.defaultProps = {
  tip: undefined,
  disabled: false,
};

IconButton.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  tip: PropTypes.node,
};

export default IconButton;
